import { render, staticRenderFns } from "./commentProductItem.vue?vue&type=template&id=5fd6c90e&scoped=true&lang=html&"
import script from "./commentProductItem.vue?vue&type=script&lang=js&"
export * from "./commentProductItem.vue?vue&type=script&lang=js&"
import style0 from "./commentProductItem.vue?vue&type=style&index=0&id=5fd6c90e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd6c90e",
  null
  
)

export default component.exports